/**
* DevExpress Dashboard (_parameter-dialog-binder.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { ParametersCollection } from '../../data/_parameters';
import { DisposableObject } from '../../model/disposable-object';
import { Parameter } from '../../model/parameters/parameter';
import { parameterTypes } from '../../viewer-parts/widgets/dialogs/_parameters-dialog';
export class ParameterDialogViewModel extends DisposableObject {
    _getParameterValues(parameter) {
        var parameterValues = null;
        if (!!parameter.staticListLookUpSettings()) {
            parameterValues = parameter.staticListLookUpSettings().values().map(item => {
                return {
                    Value: item.value(),
                };
            });
        }
        else if (!!parameter.dynamicListLookUpSettings()) {
            parameterValues = this._getParameterValuesCallback(parameter.type(), parameter.dynamicListLookUpSettings(), false)();
        }
        return parameterValues;
    }
    _getParameterDefaultValue(param, paramValues) {
        if (param.lookUpSourceType() !== 'None' && param.allowMultiselect()) {
            if (param.selectAllValues()) {
                return paramValues && paramValues.map(value => value.Value) || [];
            }
            else {
                return param._valuesOfDefaultValues() || [];
            }
        }
        else {
            return param.defaultValue();
        }
    }
    constructor(_parameters, getParameterValues) {
        super();
        this._parameters = _parameters;
        this._getDashboardParameterType = (type) => {
            var result = parameterTypes.string;
            if (type) {
                if (type.indexOf('DateTime') > -1) {
                    result = parameterTypes.dateTime;
                }
                else if ((type.indexOf('Decimal') + (type.indexOf('Double'))) > -2) {
                    result = parameterTypes.float;
                }
                else if (type.indexOf('Boolean') > -1) {
                    result = parameterTypes.bool;
                }
                else if (type.indexOf('.Int') > -1) {
                    result = parameterTypes.int;
                }
            }
            return result;
        };
        this.setParameters = (newParameters, updateCollection = true) => {
            newParameters.forEach(newParameter => {
                const name = newParameter.getName && newParameter.getName() || newParameter.Name;
                const value = newParameter.getValue && newParameter.getValue() || newParameter.Value;
                var parameterModel = this._parameters.peek().filter(p => p.name.peek() === name)[0];
                if (parameterModel) {
                    updateCollection && this._parametersCollection.setParameterValue(name, value);
                    parameterModel._value(value);
                }
            });
        };
        this._getParameterValuesCallback = getParameterValues;
        this.parameterCollection = ko.computed(() => {
            var parameters = this._parameters();
            const recreateCollection = !this._parametersCollection;
            const parametersViewModel = parameters.map(param => {
                var values = this._getParameterValues(param);
                return {
                    Name: param.name(),
                    DefaultValue: this._getParameterDefaultValue(param, values),
                    Description: param.description(),
                    Values: values,
                    ContainsDisplayMember: param.containsDisplayMember(),
                    Visible: param.parameterVisible(),
                    AllowMultiselect: param.allowMultiselect(),
                    AllowNull: param.allowNull(),
                    Type: this._getDashboardParameterType(param.type()),
                    OriginalType: param.type(),
                    DynamicListLookUpSettings: param.dynamicListLookUpSettings,
                    SelectAllValues: param.selectAllValues()
                };
            });
            if (recreateCollection) {
                this._parametersCollection = new ParametersCollection(parametersViewModel);
            }
            else {
                this._parametersCollection.refreshParameters(parametersViewModel);
            }
            parameters.forEach(param => {
                var actualValue = param._actualValue();
                if (actualValue === Parameter.SelectAllValue) {
                    actualValue = this._getParameterValues(param).map(valueViewModel => valueViewModel.Value);
                }
                this._parametersCollection.setParameterValue(param.name(), actualValue);
            });
            if (recreateCollection)
                this._parametersCollection.collectionChanged.add(() => {
                    this.setParameters(this._parametersCollection.getParameterList(), false);
                });
            return this._parametersCollection;
        });
        this.toDispose(this.parameterCollection);
    }
}
